import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
var _excluded = ["alt", "src", "srcset", "sizes", "width", "height"];
/**
 *
 * Image
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@fil-react-components/with-styles';
import styles from './Image.style';
var Image = function Image(_ref) {
  var alt = _ref.alt,
    src = _ref.src,
    srcset = _ref.srcset,
    sizes = _ref.sizes,
    width = _ref.width,
    height = _ref.height,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("img", _extends({
    alt: alt,
    src: src,
    srcSet: srcset && srcset.map(function (descriptor) {
      return "".concat(descriptor.path, " ").concat(descriptor.size);
    }).join(',') || undefined,
    sizes: sizes && sizes.map(function (size) {
      return size.mediaCondition ? "".concat(size.mediaCondition, " ").concat(size.size) : "".concat(size.size);
    }).join(',') || undefined,
    width: width,
    height: height
  }, extraProps));
};
Image.defaultProps = {
  className: '',
  srcset: undefined,
  sizes: undefined,
  width: '',
  height: ''
};
Image.displayName = 'Image';
Image.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  })),
  sizes: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.string.isRequired,
    mediaCondition: PropTypes.string
  })),
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
};
export default withStyles(Image, styles);